'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Email = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _templates = require('redux/modules/templates');

var _createTemplateComponent = require('helpers/createTemplateComponent');

var _createTemplateComponent2 = _interopRequireDefault(_createTemplateComponent);

var _templateModeTypes = require('constants/templateModeTypes');

var _Email = require('components/common/Email');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = exports.Email = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email(props) {
    (0, _classCallCheck3.default)(this, Email);
    return (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).call(this, props));
  }

  (0, _createClass3.default)(Email, [{
    key: '_getStyle',


    // componentWillMount() {
    //   const { template, templateParam } = this.props;
    //
    //   // TEMPLATE NOT SPECIFIED
    //   if (!templateParam && (!template || !template.isNew)) {
    //     this.props.setCurrentTemplate(null, true);
    //   }
    //
    //   // TEMPLATE SPECIFIED
    //   if (templateParam && (!template || String(template.id) !== String(templateParam))) {
    //     this.props.setCurrentTemplate(templateParam);
    //   }
    // }

    // shouldComponentUpdate(nextProps) {
    //   const { template, templateParam } = this.props;
    //   const { template: nextTemplate, templateParam: nextTemplateParam } = nextProps;
    //
    //   // WARNING: Only changes if other different template is chosen.
    //   const differentIds = (template && template.id) !== (nextTemplate && nextTemplate.id);
    //   const differentParams = templateParam !== nextTemplateParam;
    //
    //   return differentIds || differentParams;
    // }

    value: function _getStyle() {
      var commonTableStyles = {
        textSizeAdjust: '100%',
        borderCollapse: 'collapse',
        margin: '0px auto',
        tableRspace: '0pt',
        tableLspace: '0pt'
      };

      return (0, _reactcss2.default)({
        default: {
          root: (0, _extends3.default)({}, commonTableStyles),
          innerTable: (0, _extends3.default)({}, commonTableStyles, {
            maxWidth: '600px'
          })
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var style = this._getStyle();
      var _props = this.props,
          template = _props.template,
          basket = _props.basket;

      var root = template && template.components && template.components.root;
      var RootComponent = (0, _createTemplateComponent2.default)(root, _templateModeTypes.EMAIL);

      var logo = template.logo || 'data:image/gif;base64,R0lGODlhEAAQAMQAAORHHOVSKudfOulrSOp3WOyDZu6QdvCchPGolfO0o/XBs/fNwfjZ0frl3/zy7////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAkAABAALAAAAAAQABAAAAVVICSOZGlCQAosJ6mu7fiyZeKqNKToQGDsM8hBADgUXoGAiqhSvp5QAnQKGIgUhwFUYLCVDFCrKUE1lBavAViFIDlTImbKC5Gm2hB0SlBCBMQiB0UjIQA7';
      var logoAlignment = template.logoAlignment || 'left';

      return _react2.default.createElement(
        'html',
        null,
        _react2.default.createElement('head', null),
        _react2.default.createElement(
          'body',
          null,
          _react2.default.createElement(
            _Email.Table,
            { width: '100%', style: style.root },
            _react2.default.createElement(
              _Email.TBody,
              null,
              _react2.default.createElement(
                _Email.TR,
                null,
                _react2.default.createElement(
                  _Email.TD,
                  null,
                  _react2.default.createElement(
                    _Email.Table,
                    { width: '100%', style: style.innerTable },
                    _react2.default.createElement(
                      _Email.TBody,
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { style: { textAlign: logoAlignment } },
                          _react2.default.createElement('img', { src: logo })
                        )
                      ),
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          null,
                          'Trip Quotes'
                        )
                      ),
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          null,
                          'Reference Number: ',
                          basket.header.refNum
                        )
                      ),
                      _react2.default.createElement(
                        _Email.TR,
                        null,
                        _react2.default.createElement(
                          _Email.TD,
                          null,
                          (RootComponent || null) && _react2.default.createElement(RootComponent, null)
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Email;
}(_react.Component), _class.preload = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return [[_templates.setCurrentTemplateSaga, {
    template: params.template,
    isNew: !params.template,
    token: params.token
  }]];
}, _class.propTypes = {
  token: _react.PropTypes.string,
  template: _react.PropTypes.object,
  templateParam: _react.PropTypes.string,
  setCurrentTemplate: _react.PropTypes.func
}, _temp);


var mapStateToProps = function mapStateToProps(state, routing) {
  var components = state.templateApplication.templates.currentTemplate.components;
  var template = state.templateApplication.templates.currentTemplate;
  var shopOptions = state.rendering.shopOptions;

  return {
    components: components,
    template: template,
    basket: shopOptions
    // header,
    // footer,
    // options, // should options be called basket, what else does basket contain??
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { setCurrentTemplate: _templates.setCurrentTemplate })(Email);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Email/Email.jsx
// module id = 1627
// module chunks = 0